import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'highlight'
})
export class HighlightPipe implements PipeTransform {

  transform(value: string, search: string): string {
      if (!search) return value;

      // Create regex to match all case-insensitive occurrences of search
      const regex = new RegExp(`(${search})`, 'gi');

      // Replace all matches with highlighted version
      return value.replace(regex, `<b>$1</b>`);
      
    // if (!search) return value;

    // let result = '';
    // let searchIndex = 0;

    // for (let i = 0; i < value.length; i++) {
    //   if (
    //     searchIndex < search.length &&
    //     value[i].toLowerCase() === search[searchIndex].toLowerCase()
    //   ) {
    //     result += `<b>${value[i]}</b>`;
    //     searchIndex++;
    //   } else {
    //     result += value[i];
    //   }
    // }

    // return result;
  }
  
}
